import { MouseEventHandler } from "react";
import styled, { css } from "styled-components";
import { responsive } from "../../utils/style";
import intl from "../../services/intl";

// Components
import MagicModal from "../MagicModal";
import NYS26PromoDetails from "./promotionInfo/NYS26PromoDetails";
import WelcomeOfferDetails from "./promotionInfo/WelcomeOfferDetails";

const modalContentStyle = css`
  padding: 16px;
  width: 100%;
  max-width: 327px;
  max-height: 480px;
  overflow-y: auto;
  border-radius: 12px;

  ${responsive.sm`
    padding: 16px;
  `}

  ${responsive.md`
    padding: 16px;
    max-width: 400px;
    max-height: 560px;
  `}

  ${responsive.lg`
    padding: 16px;
  `}
`;

const modalCloseButtonStyle = css`
  && {
    position: sticky;
    top: 0;
    right: 0;
    margin-left: auto;
    margin-top: -16px;
    margin-bottom: -32px;
    height: 32px;
    width: 32px;
    background: var(--neutral-cool-20, #F5F7F8);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;

    svg {
      position: absolute;
      top: 16px;
      left: 16px;
      transform: translate(-50%, -50%);
      width: 12px;
      height: 12px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const Header = styled.div`
  position: sticky;
  top: -16px;
  padding-top: 16px;
  padding-bottom: var(--spacing-1);
  padding-left: 16px;
  padding-right: 16px;
  margin-top: -16px;
  margin-left: -16px;
  margin-right: -16px;
  margin-bottom: var(--spacing-1);
  border-bottom: 0.5px solid var(--neutral-cool-60, #DBE2E6);
  background: white;
  z-index: 1;
`;

const Title = styled.h3`
  margin-bottom: 0;
`;

type NewPromotionDetailsModalProps = {
  promotion: any;
  isOpen: boolean;
  onCloseClick: MouseEventHandler;
};

const isWelcomeOfferSlug = (slug?: string) =>
  slug === "welcome" || slug === "welcome-offer-bundle" || slug === "bundle-promotion";

const NewPromotionDetailsModal = ({
  promotion,
  isOpen,
  onCloseClick,
}: NewPromotionDetailsModalProps) => {
  const promotionSlug = promotion?.slug;

  return (
    <MagicModal
      isOpen={isOpen}
      onRequestClose={onCloseClick}
      slideOut={false}
      contentStyle={modalContentStyle}
      modalCloseButtonStyle={modalCloseButtonStyle}
    >
      <Content>
        <Header>
          <Title className="typography-lead1">{intl.t("promo.details.title", "Promo Details")}</Title>
        </Header>
        {isWelcomeOfferSlug(promotionSlug) ? (
          <WelcomeOfferDetails promotion={promotion} />
        ) : (
          <NYS26PromoDetails promotion={promotion} />
        )}
      </Content>
    </MagicModal>
  );
};

export default NewPromotionDetailsModal;